
export const ListingCountResolver = {
	productListingCount: () => ({
		basic: 1234567,
		enhanced: 3234567890,
		premium: 32,
		submissions: 12345678 
	})
}